<script setup>
import { computed, useSlots, inject } from "vue";

const events = inject("events");

const slots = useSlots();

const suggestionValue = computed(() => (slots.default()?.[0]?.children ?? "").trim());
</script>
<template>
    <div
        @click="events['suggestion-clicked'](suggestionValue)"
        class="block p-2 text-xs text-gray-900 whitespace-normal rounded-md cursor-pointer dark:text-white dark:hover:bg-gray-800 hover:bg-gray-200">
        <slot />
    </div>
</template>
